





































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import RichTextEditor from "./RichTextEditor.vue";
import { Getter } from "vuex-class";
import { SITE_LANG } from "../../store/getters.names";

@Component({
  name: "TextForm",
  components: {
    RichTextEditor
  }
})
export default class TextForm extends Vue {
  @Prop() anchor: number;
  @Prop() value: any;
  @Prop() lang: string;
  internalValue: any = JSON.parse(JSON.stringify(this.value));

//mounted() {
   // console.log(typeof this.internalValue);
  //this.internalValue = JSON.parse(JSON.stringify(this.value));
//}

  @Watch("internalValue", { deep: true })
  handleChange(val: any, oldVal: any) {
    val.text = val.text_en;
    this.$emit("input", val);
  }
}
